import { render } from "./ModelSelectHeader.vue?vue&type=template&id=5b12f905&scoped=true"
import script from "./ModelSelectHeader.vue?vue&type=script&lang=js"
export * from "./ModelSelectHeader.vue?vue&type=script&lang=js"

import "./ModelSelectHeader.vue?vue&type=style&index=0&id=5b12f905&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b12f905"]])

export default __exports__